import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"

const loadingStyles = css`
	position: relative;

	div{
		display: flex;
		text-align: center;
		font-size: small;
		padding: 2rem 0;
		justify-content: center;
		align-items: center;
		gap: 2rem;
	}

	img {
		height: 100px;
		filter: brightness(0);
	}

	h2 {
		margin-bottom: 0;
	}
`

const LoadingSpinner: ReactiveComponent = () => {
	return () => (
		<div class={loadingStyles}>
			<div>
				<img src="./SPA/media/loadingSpinner.svg" />
				<h2 >Loading...</h2>
			</div>
		</div>
	)
}

export default defineComponent(LoadingSpinner)
